// extracted by mini-css-extract-plugin
export default {"topicTitle":"b_L76zP1","scrollButton":"_8_gcgJ9","scrollButtonText":"DLl6ikav"};